import Vue from 'vue';
import Router from 'vue-router';
import more from '../components/more'


Vue.use(Router);
Vue.component('more',more)


const _import = require('./_import_' + process.env.NODE_ENV)
const routes = [
  {
    path: '*',
    redirect: '/index'
  },
  {
    name: 'index',
    component: _import('index'),
    meta: {
      title: window.g.indexTitle
    }
  },
  {
    name: 'gpList',
    component: _import('gpList'),
    meta: {
      title: '高频服务页'
    }
  },
  {
    name: 'telbook',
    component: _import('telbook'),
    meta: {
      title: '找电话'
    }
  },
  {
    name: 'policyfile',
    component: _import('policyfile'),
    meta: {
      title: '找表格'
    }
  },
  {
    name: 'location',
    component: _import('location'),
    meta: {
      title: '找位置'
    }
  },
  {
    name: 'fileDepartment',
    component: _import('fileDepartment'),
    meta: {
      title: '找表格'
    }
  },
  {
    name: 'developer',
    component: _import('developer'),
    meta: {
      title: '开发中'
    }
  },
  {
    path: '/highList',
    name: 'highList',
    component: _import('highList'),
    meta: {
      title: window.g.areaName+'高频服务事项'
    }
  },{
    path: '/highList',
    name: 'more',
    component: more
  },
  {
    path: '/frindex',
    name: 'frindex',
    component: _import('frindex'),
    meta: {
      title: '法人首页'
    }
  },
  {
    path: '/frList',
    name: 'frList',
    component: _import('frList'),
    meta: {
      title: window.g.areaName+'高频服务事项'
    }
  },
  {
    path: '/news',
    name: 'news',
    component: _import('news'),
    meta: {
      title: '公告内容'
    }
  },
  {
    path: '/newList',
    name: 'newList',
    component: _import('newList'),
    meta: {
      title: '公告列表'
    }
  },
  {
    path: '/map',
    name: 'map',
    component: _import('map'),
    meta: {
      title: '地图'
    }
  },
  {
    path: '/userCenter',
    name: 'userCenter',
    component: _import('userCenter'),
    meta: {
      title: '个人中心'
    }
  },
  {
    path: '/comCenter',
    name: 'comCenter',
    component: _import('comCenter'),
    meta: {
      title: '企业中心'
    }
  },
  {
    path: '/exposure',
    name: 'exposure',
    component: _import('exposure'),
    meta: {
      title: '办事随拍'
    }
  },
  {
    path: '/pdfViewer',
    name: 'pdfViewer',
    component: _import('pdfViewer'),
    meta: {
      title: '文件查看'
    }
  },
  {
    path: '/500',
    name: '500',
    component: _import('500'),
    meta: {
      title: '出错了'
    }
  },
];

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

const router = new Router({  routes: routes });


router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

export {
  router
};



// WEBPACK FOOTER //
// ./src/router/index.js